import React, { useState, useEffect } from "react";
import { string, object, number, array, bool } from "prop-types";
import { WithLazy } from "@quintype/components";
import { get } from "lodash";
import styles from "./styles.m.css";
import Media from "react-media";
import { DfpAd } from "../../atoms/dfp-ad";
// import { DeepBI } from "../../../integrations";
import { getParentSection } from "../../../data/section";
import { connect } from "react-redux";
import { isPremium } from "../../../data/story";
import { TaboolaAd } from "../../atoms/taboola-ad";
import SubscribeBanner from "../../atoms/remove-ads-banner";
import { checkAppSlug } from "../../utils/utils";

const proptypeSet1 = {
  mobile: string,
  adtype: string,
  story: object,
  storyId: string,
  placement: string,
  className: string,
  DesktopAdtype: string,
  MobileAdtype: string,
  unit: string,
  class: string,
  showRemoveAds: bool
};

const proptypeSet3 = {
  adId: string,
  adSize: array,
  minHeight: number,
  adDivId: string,
  class: string,
  story: object,
  showRemoveAds: bool
};

const VikatanResponsiveContainer = ({ adtype, placement, storyId = "", className, story }) => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);

  const generateAdSlotName = index => {
    if (index >= 1 && index <= 3) {
      return `MID${index}`;
    } else if (index >= 4 && index <= 5) {
      return `BTF${index - 3}`;
    } else if (index >= 5) {
      return "BTF2";
    } else {
      return `MID1`;
    }
  };

  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <WithLazy margin="300px">
          {() => (
            <div className={`vikatan-top-ad-width ad`}>
              <div className="ad-container vikatan-top-ad">
                <Media query="(min-width:768px)">
                  <div className={`desktop ad_300_250`}>
                    <PGAdwithAd
                      adId={`Vikatan2023_Desktop_AP_${generateAdSlotName(adtype)}_336x280`}
                      adSize={[[336, 280], [300, 250]]}
                      minHeight={280}
                      adDivId={`div-ad-desk-3849069-1690281136-3_${generateAdSlotName(adtype)}_${adtype}_${storyId}`}
                      class=""
                      story={story}
                    />
                  </div>
                </Media>
                {adtype !== 1 && (
                  <Media query="(max-width:768px)">
                    <div className={`mobile ad_300_250`}>
                      <PGAdwithAd
                        adId={`Vikatan2023_Mobile_AP_${generateAdSlotName(adtype - 1)}_336x280`}
                        adSize={[[336, 280], [300, 250]]}
                        minHeight={280}
                        adDivId={`div-ad-desk-3849069-1690281338-0-${generateAdSlotName(adtype - 1)}_${adtype -
                          1}_${storyId}`}
                        class=""
                        story={story}
                      />
                    </div>
                  </Media>
                )}
              </div>
            </div>
          )}
        </WithLazy>
      )}
    </React.Fragment>
  );
};

VikatanResponsiveContainer.propTypes = proptypeSet1;

const VikataninterstitialBase = props => {
  const story = get(props, ["getStory"], {});

  return (
    <div style={{ height: "0px" }}>
      <PGAdwithAd
        adId={`Vikatan_Interstitial_1x1`}
        adSize={[[1, 1]]}
        minHeight={0}
        adDivId={`div-ad-desk-3849069-1637135903666-0`}
        class=""
        story={story}
        showRemoveAds={false}
      />
      <PGAdwithAd
        adId={`Vikatan_HVR_1x1`}
        adSize={[[1, 1]]}
        minHeight={0}
        adDivId={`div-ad-desk-3849069-1690281988-0`}
        class=""
        story={story}
        showRemoveAds={false}
      />
    </div>
  );
};

VikataninterstitialBase.propTypes = proptypeSet1;

const Vikatanveveadslot = () => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <div className="vikatan-top-ad-width ad-container-outer">
          <div className="ad-container ad-320x100-veve">
            <div className={styles["veve-link-text"]}>Sponsored links</div>
            <Media query="(min-width:768px)">
              <div className="desktop">
                <PGAdwithAd
                  adId={`VeVe_Vikatan2024_Desktop_320x100`}
                  adSize={[[320, 100]]}
                  minHeight={100}
                  adDivId={`div-ad-desk-3849069-1712226878-0`}
                  class=""
                />
              </div>
            </Media>
            <Media query="(max-width:768px)">
              <div className="mobile">
                <PGAdwithAd
                  adId={`VeVe_Vikatan2024_Mobile_320x100`}
                  adSize={[[320, 100]]}
                  minHeight={100}
                  adDivId={`div-ad-mob-3849069-17122039303983-0`}
                  class=""
                />
              </div>
            </Media>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

Vikatanveveadslot.propTypes = proptypeSet1;

const VikatanResponsiveHeader = () => {
  return (
    <div styleName="vikatan-top-ad-width ad">
      <div styleName="ad-container vikatan-top-ad">
        <div styleName="desktop hidden-mobile">
          <Media query="(min-width:768px)">
            <DfpAd adtype={`Vikatan_Desktop_AP_ATF_728x90`} placement="home" className="ad-728x90" hidetitle={true} />
          </Media>
        </div>
        <div styleName="mobile hidden-desktop">
          <Media query="(max-width:768px)">
            <DfpAd adtype={`Vikatan_Mobile_AP_TOP_320x100`} placement="all" className="ad-320x100" hidetitle={true} />
          </Media>
        </div>
      </div>
    </div>
  );
};

VikatanResponsiveHeader.propTypes = proptypeSet1;

const VikatanEndArticle = (adtype, placement, storyId = "", className, story) => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <div className={styles["vikatan-end-ad"]}>
          <div styleName="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div styleName="desktop">
                <PGAdwithAd
                  adId={`Vikatan2023_Desktop_AP_BTF_468x60`}
                  adSize={[[468, 60]]}
                  minHeight={60}
                  adDivId={`div-ad-desk-3849069-1690457993-1_${storyId}`}
                  class="ad-468x60"
                  story={story}
                />
              </div>
            </Media>
            <Media query="(max-width:768px)">
              <div styleName="mobile">
                <PGAdwithAd
                  adId={`Vikatan2023_Mobile_AP_BTF_320x100`}
                  adSize={[[320, 100]]}
                  minHeight={100}
                  adDivId={`div-ad-desk-3849069-1690281338-6_${storyId}`}
                  class="ad-320x100"
                />
              </div>
            </Media>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

VikatanEndArticle.propTypes = proptypeSet1;

const VikatanBetweenArticle = (adtype, placement, story) => {
  return (
    <WithLazy margin="300px">
      {() => (
        <div styleName="vikatan-top-ad-width ad">
          <div styleName="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div className="desktop article-between">
                <div className="container article-btw-ad">
                  <PGAdwithAd unit="Vikatan_article_leaderboard_mid" class="between-article" story={story} />
                </div>
              </div>
            </Media>
            <Media query="(max-width:768px)">
              <div className="mobile article-between">
                <PGAdwithAd unit="Vikatan_mobile_article_leaderboard_top" class="between-article" story={story} />
              </div>
            </Media>
          </div>
        </div>
      )}
    </WithLazy>
  );
};

VikatanBetweenArticle.propTypes = proptypeSet1;

const VikatanSticky = (placement, storyId = "home", story) => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <div>
          <AdExchangeScript />
          <Media query="(max-width:768px)">
            {matches =>
              matches && (
                <div className={styles["sticky-ad"]}>
                  <PGAdwithAd
                    adId={`Vikatan2023_Mobile_Sticky_320x50`}
                    adSize={[[320, 50]]}
                    minHeight={50}
                    adDivId={`div-ad-desk-3849069-1690281477-0_${storyId}`}
                    className="hidden-desktop"
                    story={placement.story}
                  />
                </div>
              )
            }
          </Media>
        </div>
      )}
    </React.Fragment>
  );
};

const VikatanDesktopSticky = (placement, storyId = "home", story) => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <div>
          <Media query="(min-width:768px)">
            {matches =>
              matches && (
                <div>
                  <div className={styles["sticky-ad-desktop"]}>
                    <PGAdwithAd
                      adId={`Vikatan2024_Desktop_Sticky_Multisize_970x90`}
                      adSize={[[970, 90]]}
                      minHeight={90}
                      adDivId={`div-ad-desk-3849069-1717581619`}
                      className=""
                    />
                  </div>
                </div>
              )
            }
          </Media>
        </div>
      )}
    </React.Fragment>
  );
};

const VikatanStickyTop = (placement, storyId = "home", story) => {
  return (
    <div>
      <Media query="(max-width:768px)">
        <div className={styles["sticky-ad-top"]}>
          <PGAdwithAd
            adId={`Vikatan2024_Mobile_StickyTOP_320x50_USmarket`}
            adSize={[[320, 50]]}
            minHeight={50}
            adDivId={`div-ad-desk-3849069-1697-0_${storyId}`}
            className="hidden-desktop"
            story={placement.story}
            showRemoveAds={false}
          />
        </div>
      </Media>
    </div>
  );
};

VikatanStickyTop.propTypes = proptypeSet1;

const VikatanTowerAd = ({ adtype, placement, story, className }) => {
  return (
    <div className={`${className} ${styles["ad"]}`}>
      <Media query="(min-width:768px)">
        <DfpAd story={story} adtype={adtype} placement={placement} />
      </Media>
    </div>
  );
};

VikatanTowerAd.propTypes = proptypeSet1;

const VikatanHeaderAd = ({ adtype, placement, story, className }) => {
  return (
    <div className={`${className} ${styles["ad"]}`}>
      <Media query="(min-width:768px)">
        <div className={`${styles["ad-top-header"]} hidden-mobile`}>
          <PGAdwithAd
            adId={`Vikatan2023_Desktop_HP_Top_428x70`}
            adSize={[[428, 70]]}
            minHeight={70}
            adDivId={`div-ad-desk-3849069-1690809523-0`}
            class=""
            showRemoveAds={false}
          />
        </div>
      </Media>
    </div>
  );
};

VikatanHeaderAd.propTypes = proptypeSet1;

const VikatanCollectionResponsive = ({ DesktopAdtype, MobileAdtype, placement, adtype = 1 }) => {
  return (
    <WithLazy margin="300px">
      {() => (
        <div className="vikatan-top-ad-width ad">
          <div className="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div className="desktop">
                <PGAdwithAd
                  adId={DesktopAdtype}
                  adSize={[[970, 90], [728, 90]]}
                  minHeight={90}
                  adDivId={`div-ad-desk-3849069-16179-0${adtype}`}
                  class="ad-728x90"
                />
              </div>
            </Media>
            <Media query="(max-width:768px)">
              <div className="mobile">
                <PGAdwithAd
                  adId={MobileAdtype}
                  adSize={[[320, 100]]}
                  minHeight={100}
                  adDivId={`div-ad-desk-3849069-1690280-0${adtype}`}
                  class="ad-320x100"
                />
              </div>
            </Media>
          </div>
        </div>
      )}
    </WithLazy>
  );
};

VikatanCollectionResponsive.propTypes = proptypeSet1;

const VikatanHomeCollectionResponsive = ({ DesktopAdtype, MobileAdtype, placement, adtype = 1 }) => {
  return (
    <WithLazy margin="300px">
      {() => (
        <div className="vikatan-top-ad-width ad">
          <div className="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div className="desktop">
                <PGAdwithAd
                  adId={DesktopAdtype}
                  adSize={[[970, 90], [728, 90]]}
                  minHeight={90}
                  adDivId={`div-ad-desk-3849069-777-01${adtype}`}
                  class="ad-728x90"
                />
              </div>
            </Media>
            <Media query="(max-width:768px)">
              <div className="mobile">
                <PGAdwithAd
                  adId={MobileAdtype}
                  adSize={[[300, 250], [336, 280]]}
                  minHeight={280}
                  adDivId={`div-ad-desk-3849069-85741-0${adtype}`}
                  class="ad_300_250"
                />
              </div>
            </Media>
          </div>
        </div>
      )}
    </WithLazy>
  );
};

VikatanHomeCollectionResponsive.propTypes = proptypeSet1;

const VikatanHomeStaticAdDesktop = () => {
  return (
    <WithLazy margin="300px">
      {() => (
        <div className="vikatan-top-ad-width ad">
          <div className="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div className="desktop">
                <PGAdwithAd
                  adId={`Vikatan2023_Desktop_HP_MID1_970x250`}
                  adSize={[[970, 250]]}
                  minHeight={250}
                  adDivId={`div-ad-desk-3849069-1690280771-3`}
                  class="ad-top-bottom-space"
                />
              </div>
            </Media>
          </div>
        </div>
      )}
    </WithLazy>
  );
};

VikatanHomeStaticAdDesktop.propTypes = proptypeSet1;

const VikatanMainResponsive = ({ placement, DesktopAdtype, MobileAdtype }) => {
  let pagetypeUnit = placement === "home" ? "HP" : "SP";
  return (
    <WithLazy margin="300px">
      {() => (
        <div className="vikatan-top-ad-width ad">
          <div className="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div className="desktop hidden-mobile">
                {placement === "home" ? (
                  <PGAdwithAd
                    adId={`Vikatan2023_Desktop_${pagetypeUnit}_RightMID_300x250`}
                    adSize={[300, 250]}
                    minHeight={250}
                    adDivId="div-ad-desk-3849069-1690280367-0"
                    class="ad_300_250"
                  />
                ) : (
                  <PGAdwithAd
                    adId={`Vikatan2023_Desktop_${pagetypeUnit}_RightMID_336x280`}
                    adSize={([336, 280], [300, 250])}
                    minHeight={280}
                    adDivId="div-ad-desk-3849069-1690280367-12"
                    class="ad_300_250"
                  />
                )}
              </div>
            </Media>
            <Media query="(max-width:768px)">
              <div className="mobile hidden-desktop">
                <PGAdwithAd
                  adId={`Vikatan2023_Mobile_${pagetypeUnit}_ATF_336x280`}
                  adSize={[[336, 280], [300, 250]]}
                  minHeight={280}
                  adDivId="div-ad-desk-3849069-16902805177-0"
                  class="ad_300_250"
                />
              </div>
            </Media>
          </div>
        </div>
      )}
    </WithLazy>
  );
};

VikatanMainResponsive.propTypes = proptypeSet1;

const VikatanHomeHeader = () => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <div className={styles["header-ad-unit"]} styleName="ad-container vikatan-top-ad sd">
          <div className="desktop hidden-mobile">
            <Media query="(min-width:768px)">
              <PGAdwithAd
                adId={`Vikatan2023_Desktop_HP_TOP_970x90`}
                adSize={[[970, 90], [728, 90]]}
                minHeight={90}
                adDivId="div-ad-desk-3849069-1690280367-2"
                class="ad-728x90"
                showRemoveAds={false}
              />
            </Media>
          </div>
          <div className="mobile hidden-desktop">
            <Media query="(max-width:768px)">
              <PGAdwithAd
                adId={`Vikatan2023_Mobile_HP_TOP_320x100`}
                adSize={[320, 100]}
                minHeight={100}
                adDivId="div-ad-desk-3849069-16902805178-0"
                class="ad-320x100"
                showRemoveAds={false}
              />
            </Media>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

VikatanHomeHeader.propTypes = proptypeSet1;

const VikatanSectionHeader = () => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <div className={styles["header-ad-unit"]} styleName="ad-container vikatan-top-ad">
          <div className="desktop hidden-mobile">
            <Media query="(min-width:768px)">
              <PGAdwithAd
                adId={`Vikatan2023_Desktop_SP_ATF_970x90`}
                adSize={[[970, 90], [728, 90]]}
                minHeight={90}
                adDivId="div-ad-desk-3849069-1690280998-2"
                class="ad-728x90"
              />
            </Media>
          </div>
          <div className="mobile hidden-desktop">
            <Media query="(max-width:768px)">
              <PGAdwithAd
                adId={`Vikatan2023_Mobile_SP_TOP_320x100`}
                adSize={[[320, 100]]}
                minHeight={100}
                adDivId="div-ad-desk-3849069-1690280872-0"
                class="ad-320x100"
              />
            </Media>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

VikatanSectionHeader.propTypes = proptypeSet1;

const VikatanAsidebar = () => {
  return (
    <div>
      <Media query="(min-width:768px)">
        <PGAdwithAd
          adId={`Vikatan2023_Mobile_SP_MID1_336x280`}
          adSize={[[336, 280], [300, 250], [320, 100], [320, 50]]}
          minHeight={280}
          adDivId="div-ad-desk-3849069-1690280875-1"
          class="ad_300_250"
        />
      </Media>

      <div className={`${styles["ad-halfpage"]} hidden-mobile`}>
        <PGAdwithAd unit="Vikatan2023_Desktop_AP_RHS_300x600" class="ad-300x600" />
      </div>
    </div>
  );
};

VikatanAsidebar.propTypes = proptypeSet1;

const VikatanStoryHeader = () => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <div styleName="vikatan-top-ad-width ad">
      <div styleName="ad-container vikatan-top-ad">
        {userType === "P" || userType === "T" || userType === "R" ? (
          <div />
        ) : (
          <div className={`desktop hidden-mobile`}>
            <Media
              query="(min-width: 768px)"
              render={() => (
                <div className={`${styles["header-ad-unit"]}`}>
                  <PGAdwithAd
                    adId={`Vikatan2023_Desktop_AP_ATF_970x90`}
                    adSize={[[970, 90], [728, 90]]}
                    minHeight={90}
                    adDivId="div-ad-desk-3849069-1690281136-4"
                    class="ad-728x90"
                    showRemoveAds={false}
                  />
                </div>
              )}
            />
          </div>
        )}
      </div>
    </div>
  );
};
VikatanStoryHeader.propTypes = proptypeSet1;

const VikatanGalleryArticle = (adtype, placement, story, className) => {
  return (
    <div styleName="ad-container vikatan-top-ad">
      <PGAdwithAd unit="Vikatan_mobile_article_gallery" class="ad_300_250" />
    </div>
  );
};

VikatanGalleryArticle.propTypes = proptypeSet1;

export const VikatanTweleCollectionAd = () => {
  const [isWebview, setIsWebview] = useState(false);
  const [userType, setUserType] = useState("F");

  useEffect(() => {
    setIsWebview(checkAppSlug());
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);

  if (isWebview || userType === "P" || userType === "T" || userType === "R") {
    return null;
  }

  return (
    <div className="ad_300_250 ad-top-bottom-space">
      <PGAdwithAd
        adId={`Vikatan2023_Mobile_HP_ATF_336x280`}
        adSize={[[336, 280], [300, 250]]}
        minHeight={280}
        adDivId="div-ad-desk-3849069-169028051743-4"
        class=""
      />
    </div>
  );
};

const PGAdwithAdBase = props => {
  const [userType, setUserType] = useState("P");
  const randomN = Math.floor(Math.random() * 10000);
  const [randomNum] = useState(randomN);
  const [adName, setAdName] = useState(props.adId);

  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });

    const hostname = global && global.location.hostname;
    if (
      ["www.anandavikatan.com", "anandavikatan.com"].includes(hostname) &&
      [
        "Vikatan2023_Desktop_AP_RightATF_336x280",
        "Vikatan2023_Desktop_AP_RightMID_336x280",
        "Vikatan_HVR_1x1"
      ].includes(adName)
    ) {
      let newunitName = `A${adName}`;
      if (adName === "Vikatan_HVR_1x1") {
        newunitName = "AnandaVikatan_HVR_1x1";
      }
      setAdName(newunitName);
    }
  }, []);

  if (props.disableAds) {
    return <div />;
  }

  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <div className={props.class}>
          <StaticAdUnit
            adId={adName} // "/3849069/Vikatan2023_Desktop_HP_RightMID_300x250"
            adSize={props.adSize} // {[300, 250]}
            minHeight={props.minHeight} // {250}
            adDivId={`${props.adDivId}_${randomNum}`}
            story={get(props, ["story"], "")} // "div-ad-desk-3849069-1690280367-0"
            showRemoveAds={props.showRemoveAds}
          />
        </div>
      )}
    </React.Fragment>
  );
};

const PGAdwithAd = connect(state => ({
  disableAds: get(state, ["qt", "config", "disableAds"])
}))(PGAdwithAdBase);

PGAdwithAdBase.propTypes = {
  ...proptypeSet3,
  disableAds: bool
};

PGAdwithAd.propTypes = {
  ...proptypeSet3
};

const AdExchangeScript = () => {
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      const userType = get(user, ["userType"], "P");

      if (["P", "T", "R"].includes(userType)) return;

      const slotId = "tmsrv-9144";
      const container = document.getElementById(slotId);
      if (!container) return;

      // Prevent duplicate execution
      if (window.__tmAdLoaded) return;
      window.__tmAdLoaded = true;

      // Create command queue first
      window.tmsrv = window.tmsrv || { cmd: [] };

      window.tmsrv.cmd.push(function(adObj) {
        adObj.AdSlot(slotId);
        adObj.Meta("/tmsrvptr659/tmsrvplr807/tmsrvadu9144/TPMS-AD-vikatan.com-Direct-RSwPB-SLDR-1x1");
        adObj.CacheBuster(Date.now());
        adObj.UserConsent("0");
        adObj.Domain("Vikatan.com");
        adObj.ClickUrl("%%CLICK_URL_UNESC%%");
        adObj.ViewURL("%%VIEW_URL_UNESC%%");
        adObj.Execute();
      });

      // Load scripts only once
      if (!document.querySelector('script[src*="tmCore.js"]')) {
        const s1 = document.createElement("script");
        s1.src = "https://srv-qa.tmadsrv.com/9144.js";
        s1.async = true;

        const s2 = document.createElement("script");
        s2.src = "https://dsrv.tmadsrv.com/tmCore.js";
        s2.async = true;

        document.body.appendChild(s1);
        document.body.appendChild(s2);
      }
    });
  }, []);

  return <div id="tmsrv-9144" />;
};

AdExchangeScript.propTypes = proptypeSet3;

const StaticAdUnit = ({ adId, adSize, minHeight, adDivId, story, showRemoveAds = true, disableAds }) => {
  const theme = get(story, ["metadata", "story-attributes", "theme", 0]);
  const paidArticle = story ? isPremium(story) : false;
  const sections = [get(story, ["sections", 0], {})];
  const parentSection = getParentSection(sections[0]);
  if (parentSection) {
    sections.unshift(parentSection);
  }
  const section = get(sections, [0, "name"]) || "";
  const subSection = get(sections, [1, "name"]) || "";

  useEffect(
    () => {
      if (disableAds) return;

      if (!adId || !adSize || !adDivId) {
        console.error("adId, adSize, or adDivId is undefined. Ad slot cannot be defined.");
        return;
      }

      const googletag = global.googletag || {};
      window.googletag = window.googletag || { cmd: [] };

      if (!googletag || !googletag.cmd || typeof googletag.cmd.push !== "function") {
        console.error("Google Ad Manager setup is not available. Ad slot cannot be defined.");
        return;
      }

      googletag.cmd.push(function() {
        var adSlot = googletag.defineSlot(`/3849069/${adId}`, adSize, `${adDivId}`).addService(googletag.pubads());
        theme !== undefined && adSlot.setTargeting("theme", theme);
        section !== undefined && adSlot.setTargeting("section", section);
        subSection !== undefined && adSlot.setTargeting("subsection", subSection);
        adSlot.setTargeting("Paid_Article", paidArticle);

        googletag.enableServices();
        googletag.display(`${adDivId}`);
      });
    },
    [disableAds]
  );

  if (!adDivId || disableAds) {
    return <div />; // If adDivId is undefined or ads are disabled, don't render anything
  }

  return (
    <div>
      <div id={`${adDivId}`} style={{ minHeight: `${minHeight}px` }} />
      {showRemoveAds && adId !== "Vikatan_HVR_1x1" && adId !== "AnandaVikatan_HVR_1x1" && <SubscribeBanner />}
    </div>
  );
};

StaticAdUnit.propTypes = {
  ...proptypeSet3,
  disableAds: bool
};

const VikatanResponsiveContainerLiveblog = ({ adtype, placement, story, className }) => {
  const [userType, setUserType] = useState("F");
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" ? (
        <div />
      ) : (
        <WithLazy margin="300px">
          {() => (
            <div className={`vikatan-top-ad-width ad`}>
              <div className="ad-container vikatan-top-ad">
                <Media query="(max-width:768px)">
                  <div className={`mobile ad_300_250`}>
                    <PGAdwithAd
                      adId={`Vikatan2023_Mobile_AP_ATF_336x280`}
                      adSize={[[336, 280], [300, 250]]}
                      minHeight={280}
                      adDivId="div-ad-desk-3849069-1690281338-0"
                      class="ad_300_250"
                    />
                  </div>
                </Media>
              </div>
            </div>
          )}
        </WithLazy>
      )}
    </React.Fragment>
  );
};
VikatanResponsiveContainerLiveblog.propTypes = proptypeSet1;

const AdSenseFluidUnitBase = ({ layoutKey, slotId, disableAds }) => {
  const [userType, setUserType] = useState("P");

  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      user && setUserType(user.userType);
    });
  }, []);
  return (
    <React.Fragment>
      {userType === "P" || userType === "T" || userType === "R" || disableAds ? (
        <div />
      ) : (
        <div>
          <AdSenseStaticFluidUnit layoutKey={layoutKey} slotId={slotId} />
        </div>
      )}
    </React.Fragment>
  );
};

const AdSenseFluidUnit = connect(state => ({
  disableAds: get(state, ["qt", "config", "disableAds"])
}))(AdSenseFluidUnitBase);

const AdSenseStaticFluidUnit = ({ layoutKey, slotId }) => {
  useEffect(() => {
    // Check if the AdSense script is already included
    if (!document.querySelector('script[src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"]')) {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      script.crossOrigin = "anonymous";
      script.onload = () => {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      };
      document.head.appendChild(script);
    } else {
      // Initialize ads if the script is already present
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }
  }, []);

  return (
    <div>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-format="fluid"
        data-ad-layout-key={layoutKey} // "-h6+d+18-dl+ma"
        data-ad-client="ca-pub-2591855995238005"
        data-ad-slot={slotId} // "5035478210"
      />
      <SubscribeBanner />
    </div>
  );
};

AdSenseStaticFluidUnit.propTypes = {
  layoutKey: string,
  slotId: number
};

AdSenseFluidUnitBase.propTypes = {
  layoutKey: string,
  slotId: number,
  disableAds: bool
};

const VdoAiScriptBase = ({ disableAds }) => {
  const [userType, setUserType] = useState("P");

  useEffect(() => {
    // Fetch the userType asynchronously
    global.userPromise.catch(() => ({})).then(user => {
      if (user) {
        setUserType(user.userType);
      }
    });
  }, []);

  useEffect(
    () => {
      // Only initialize the script if userType is not "P", "T", or "R" and ads are not disabled
      if (!["P", "T", "R"].includes(userType) && !disableAds) {
        const script = document.createElement("script");
        script.defer = true;
        script.async = true;
        script.src = `${window.location.protocol}//a.vdo.ai/core/v-vikatan/vdo.ai.js`;

        document.head.appendChild(script);

        return () => {
          document.head.removeChild(script);
        };
      }
    },
    [userType, disableAds]
  );
  return <div id="v-vikatan" />;
};

const VdoAiScript = connect(state => ({
  disableAds: get(state, ["qt", "config", "disableAds"])
}))(VdoAiScriptBase);

VdoAiScriptBase.propTypes = {
  layoutKey: string,
  slotId: number,
  disableAds: bool
};

const AdbroScriptBase = ({ disableAds }) => {
  const [userType, setUserType] = useState("P");

  useEffect(() => {
    // Fetch the userType asynchronously
    global.userPromise.catch(() => ({})).then(user => {
      if (user) {
        setUserType(user.userType);
      }
    });
  }, []);

  useEffect(
    () => {
      // Only initialize the script if userType is not "P", "T", or "R" and ads are not disabled
      if (!["P", "T", "R"].includes(userType) && !disableAds) {
        const script = document.createElement("script");
        script.type = "application/javascript";

        script.innerHTML = `(function(w,d,p,c){
          var r='ptag',o='script',
          s=function(u){
            var a=d.createElement(o),
            m=d.getElementsByTagName(o)[0];
            a.async=1;
            a.src=u;
            m.parentNode.insertBefore(a,m);
          };
          w[r]=w[r]||function(){(w[r].q = w[r].q || []).push(arguments)};
          s(p);s(c);
        })(window, document, '//tag.adbro.me/tags/ptag.js', '//tag.adbro.me/configs/yfflwign.js');`;

        document.head.appendChild(script);

        return () => {
          document.head.removeChild(script);
        };
      }
    },
    [userType, disableAds]
  );

  return <div />; // This script doesn’t need a div like VdoAi
};

const AdbroScript = connect(state => ({
  disableAds: get(state, ["qt", "config", "disableAds"])
}))(AdbroScriptBase);

AdbroScriptBase.propTypes = {
  layoutKey: string,
  slotId: number,
  disableAds: bool
};

const VdoAiHomeScriptBase = ({ disableAds }) => {
  const [userType, setUserType] = useState("P");

  useEffect(() => {
    // Fetch the userType asynchronously
    global.userPromise.catch(() => ({})).then(user => {
      if (user) {
        setUserType(user.userType);
      }
    });
  }, []);

  useEffect(
    () => {
      // Only initialize the script if userType is not "P", "T", or "R" and ads are not disabled
      if (!["P", "T", "R"].includes(userType) && !disableAds) {
        const script = document.createElement("script");
        script.defer = true;
        script.async = true;
        script.src = window.location.protocol + "//a.vdo.ai/core/v-vikatan-v1/vdo.ai.js";
        script.setAttribute("data-cfasync", "false");
        document.head.appendChild(script);

        return () => {
          document.head.removeChild(script);
        };
      }
    },
    [userType, disableAds]
  );
  return <div id="v-vikatan-v1" />;
};

const VdoAiHomeScript = connect(state => ({
  disableAds: get(state, ["qt", "config", "disableAds"])
}))(VdoAiHomeScriptBase);

VdoAiHomeScriptBase.propTypes = {
  layoutKey: string,
  slotId: number,
  disableAds: bool
};

const PlayStreamAdBase = ({ disableAds }) => {
  const [userType, setUserType] = useState("P");

  useEffect(() => {
    // Fetch the userType asynchronously
    global.userPromise.catch(() => ({})).then(user => {
      if (user) {
        setUserType(user.userType);
      }
    });
  }, []);

  useEffect(
    () => {
      console.log("Initializing PlayStreamAd with userType:", userType);
      // Only initialize the script if userType is not "P", "T", or "R" and ads are not disabled
      if (!["P", "T", "R"].includes(userType) && !disableAds) {
        const script = document.createElement("script");
        script.id = "PS_695e3e72ab3cca4cb495f145";
        script.async = true;
        script.type = "text/javascript";
        script.src =
          window.location.protocol +
          "//ads.playstream.media/api/adserver/scripts?PS_TAGID=695e3e72ab3cca4cb495f145&PS_PUB_ID=67d288df5c325aa552f433b7";

        document.head.appendChild(script);

        script.onload = () => {
          if (window.PlayStream) {
            window.PlayStream.init();
          }
        };

        return () => {
          document.head.removeChild(script);
        };
      }
    },
    [userType, disableAds]
  );
  return <div id="v-vikatan-player-v2" />;
};

const PlayStreamAd = connect(state => ({
  disableAds: get(state, ["qt", "config", "disableAds"])
}))(PlayStreamAdBase);

export default PlayStreamAd;

PlayStreamAdBase.propTypes = {
  layoutKey: string,
  slotId: number,
  disableAds: bool
};

const VikatanTaboolaST = () => {
  return (
    <WithLazy margin="300px">
      {() => (
        <div className="vikatan-top-ad-width ad">
          <div className="ad-container vikatan-top-ad">
            <Media query="(min-width:768px)">
              <div className="desktop">
                <TaboolaAd
                  config={{
                    mode: "organic-thumbnails-a-stream-1x1",
                    id: "taboola-mid-article-personalisation",
                    placement: "Mid Article Personalisation"
                  }}
                  url={global && global.location && global.location.href}
                  className={"taboola-article"}
                  flush={false}
                />
              </div>
            </Media>
            <Media query="(max-width:768px)">
              <div className="mobile">
                <TaboolaAd
                  config={{
                    mode: "organic-thumbnails-a-stream-1x1-mob",
                    id: "taboola-mid-article-personalisation",
                    placement: "Mid Article Personalisation"
                  }}
                  url={global && global.location && global.location.href}
                  className={"taboola-article"}
                  flush={false}
                />
              </div>
            </Media>
          </div>
        </div>
      )}
    </WithLazy>
  );
};

function mapStateToProps(state) {
  return {
    getStory: get(state, ["qt", "data", "story"], null)
  };
}

const Vikataninterstitial = connect(mapStateToProps)(VikataninterstitialBase);

export {
  VikatanResponsiveContainer,
  VikatanResponsiveHeader,
  VikatanEndArticle,
  VikatanBetweenArticle,
  VikatanSticky,
  VikatanTowerAd,
  VikatanHeaderAd,
  VikatanCollectionResponsive,
  VikatanMainResponsive,
  VikatanHomeHeader,
  VikatanSectionHeader,
  VikatanAsidebar,
  VikatanStoryHeader,
  PGAdwithAd,
  VikatanGalleryArticle,
  Vikataninterstitial,
  VikatanResponsiveContainerLiveblog,
  VikatanHomeCollectionResponsive,
  Vikatanveveadslot,
  VikatanStickyTop,
  AdSenseFluidUnit,
  AdExchangeScript,
  VikatanDesktopSticky,
  VdoAiScript,
  VdoAiHomeScript,
  VikatanTaboolaST,
  AdbroScript,
  PlayStreamAd
};
